export default __webpack_public_path__ + "static/media/7SJ512.35d82738.png";